<template>
    <svg
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60">
        <path
            d="M13.5 16.6206C13.5 16.027 13.8636 15.4939 14.4163 15.2773L29.4735 9.37545C29.8119 9.24277 30.188 9.24277 30.5265 9.37545L45.5837 15.2773C46.1364 15.4939 46.5 16.027 46.5 16.6206V43.2355C46.5 43.8248 46.1416 44.3549 45.5947 44.5744L30.5376 50.6202C30.1926 50.7587 29.8074 50.7587 29.4624 50.6202L14.4052 44.5744C13.8584 44.3549 13.5 43.8248 13.5 43.2355V16.6206Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.1603 14.9749C30.0563 14.9379 29.9424 14.9366 29.8376 14.9713L13.8148 20.2788C13.6178 20.344 13.4853 20.5245 13.4853 20.7274V30.1441C13.4853 30.3792 13.6619 30.5787 13.9003 30.6129L29.9309 32.9125C29.9764 32.9191 30.0227 32.9193 30.0684 32.9131L38.3235 31.7946C38.5637 31.7621 38.7424 31.5618 38.7424 31.3253V18.3611C38.7424 18.1621 38.6149 17.9843 38.4232 17.916L30.1603 14.9749Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M21.3683 12.5178L21.3683 47.3856"
            stroke="#EEEEEE" />
        <path
            d="M30.0001 9.11749L30.0001 50.4032"
            stroke="#EEEEEE" />
        <path
            d="M44.5714 28.0604L44.5714 32.4319"
            stroke="#EEEEEE"
            stroke-linecap="round" />
        <path
            d="M44.0862 42.632L41.1719 43.6034"
            stroke="#EEEEEE"
            stroke-linecap="round" />
        <path
            d="M38.833 12.5178L38.833 47.3856"
            stroke="#EEEEEE" />
    </svg>
</template>

<script setup lang="ts"></script>
